import { EAppPath } from '@/web/appPath';

import { useCategoryListQuery } from '@/web/modules/categories/queries/categories.queries';

import { NavLink } from '@/web/components/navLink/navLink';

import { Grid, Stack } from '@kit/layout/layout';
import { ListIcon } from '@kit/list/list';
import { Sheet } from '@kit/sheet/sheet';
import { Title } from '@kit/title/title';

export function CategoryListView() {
	let categories = useCategoryListQuery();

	return (
		<Grid>
			{categories.map((category) => (
				<Sheet key={category.id} interactive asChild>
					<Stack className="relative" asChild>
						<NavLink to={`${EAppPath.CATEGORIES}/${category.id}`}>
							<Title>{category.name}</Title>

							<ListIcon className="absolute -right-0.5 -bottom-0.5">
								{category.icon}
							</ListIcon>
						</NavLink>
					</Stack>
				</Sheet>
			))}
		</Grid>
	);
}
